import React from 'react'
import WebMain from '../front/WebMain'
import DemoTs1Report from './ts1/DemoTs1Report'
import { Card } from 'antd'
function DemoIndex() {
    return (
        <WebMain>
            <div>
                <Card>
                    <DemoTs1Report />
                </Card>
            </div>
        </WebMain>
    )
}

export default DemoIndex